import { VerificationTransactionsState } from "@idw-types/state/verification-transactions-state";
import { VerificationTransactionsActionTypes, VerificationTransactionsActions } from "../actions/verification-transactions-actions";
import { TimeRangeTypes } from "@enums/time-range-types";
import { getTimeRange } from "@utils/date-util";

export const initialVerificationTransactionsState: VerificationTransactionsState = {
    searchFilters: {
        credentials: "",
        serviceOfferingIds: [],
        assertionIds: [],
        claimStatuses: [],
        companyIds: [],
        relyingPartyIds: [],
        rpServiceIds: [],
        appId: "",
        transactionId: "",
        policyDecisions: [],
        sessionKey: "",
        workflowIds: [],
        timeRangeType: TimeRangeTypes.TODAY,
        startDate: getTimeRange(TimeRangeTypes.TODAY).startDate,
        endDate: getTimeRange(TimeRangeTypes.TODAY).endDate,
        includeArchivedServicesAndWorkflows: false,
        countries: []
    },
    searchResults: {
        searchDate: null,
        isLoading: false,
        verificationTransactions: null,
        summary: null,
    }
}

export const verificationTransactionsReducer = (
    state: VerificationTransactionsState = initialVerificationTransactionsState,
    action: VerificationTransactionsActions
): VerificationTransactionsState => {
    switch (action.type) {
        case VerificationTransactionsActionTypes.SET_VERIFICATION_TRANSACTIONS_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case VerificationTransactionsActionTypes.SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...(action.payload.isLoading
                        ? { ...initialVerificationTransactionsState.searchResults }
                        : { ...state.searchResults }),
                    isLoading: action.payload.isLoading
                }
            };
        case VerificationTransactionsActionTypes.SET_VERIFICATION_TRANSACTIONS_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: {
                    isLoading: false,
                    searchDate: new Date(),
                    ...action.payload.verificationTransactionsSearchResults,
                }
            };
        default:
            return state;
    }
};